/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsItemsProductsCtrl
 * @description A report with sales grouped by Pos Item
 */
angular.module('mercury.modules.reports.items')
.controller('ReportsItemsOverviewCtrl', ["$filter", "$q", "ReportPosItems", "PosItemGroups", "reporttime", "$scope", "$stateParams", "title", function($filter, $q, ReportPosItems, PosItemGroups, reporttime, $scope, $stateParams, title) {
  $scope.itemsCols = [
    {label: 'Product', type: 'string', key: 'itemName'},
    {label: 'Sales', type: 'number', key: 'invoices', filter: 'currency'}
  ];

  $scope.itemsOptions = {
    sliceVisibilityThreshold: 0.01
  };

  $scope.loading = $q.all({
    items: ReportPosItems.getSales(reporttime.start(), reporttime.end()),
    itemOrders: ReportPosItems.getOrders(reporttime.start(), reporttime.end()),
    itemGroups: PosItemGroups.getOrders(reporttime.start(), reporttime.end())
  });

  title.set('Products Overview');

  $scope.loading.then(function(results) {
    $scope.itemSales = $filter('orderBy')(results.items, 'invoices', true);
    $scope.topItemGroups = $filter('orderBy')(results.itemGroups, 'amount', true);
    $scope.topItems = $filter('orderBy')(results.itemOrders, 'amount', true);

    $scope.totalOrders = $filter('sumof')(results.itemOrders, 'amount');

    var itemCategories = {};
    angular.forEach(results.items, function(item) {
      if (!itemCategories[item.itemCategoryIdentifier] && item.itemCategoryIdentifier) {
        itemCategories[item.itemCategoryIdentifier] = {
          label: item.itemCategoryName,
          id: item.itemCategoryIdentifier,
          sales: $filter('sumof')($filter('filter')(results.items, {itemCategoryIdentifier: item.itemCategoryIdentifier}, true), 'invoices')
        };
      }
    });
    $scope.itemCategories = itemCategories;

    $scope.itemCount = 0;
    $scope.itemCount = Object.keys(itemCategories).length;
  });
}]);
